var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitHub2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-109 -4718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.278,32.073V27.212c-.278-.834-.7,0-.7,0v4.861c-.9,3.4-3.472,2.777-3.472,2.777A2.91,2.91,0,0,0,12.5,32.767V27.212c-.208-1.389-.694,0-.694,0v4.166a2.9,2.9,0,0,1-.7,2.083,2.919,2.919,0,0,1-2.083.7c-1.458-.07-.694-.7-.694-.7a3.066,3.066,0,0,0,1.389-1.388V29.3c-.209-1.389-3.056-.972-4.167-1.389s-2.985-2.985-3.472-4.86S0,22.35,0,22.35c1.181-2.222,2.778-.694,2.778-.694,3.472,5.486,6.945,3.472,6.945,3.472v.416c.069-2.361,1.388-2.5,1.388-2.5h7.64s1.458.138,1.388,2.777v6.251a3.067,3.067,0,0,0,1.389,1.388s.764.625-.694.7a2.919,2.919,0,0,1-2.083-.7,2.9,2.9,0,0,1-.7-2.083V27.212s-.486-1.389-.694,0v5.555a2.909,2.909,0,0,0,1.389,2.083,2.22,2.22,0,0,1-.475.045C17.489,34.9,15.938,34.562,15.278,32.073ZM1.389,12.629a8.879,8.879,0,0,1,2.5-6.041c-.9-1.805-.7-5.487.278-6.389C5-.566,8.056,2.073,9.236,3.115a16.6,16.6,0,0,1,5.695-.972,17.684,17.684,0,0,1,5.139.764C21.389,1.726,24.167-.566,25,.128c.833.833,1.181,3.958.486,5.9a9.256,9.256,0,0,1,2.987,6.6c0,5.764-6.042,10.417-13.542,10.417S1.389,18.392,1.389,12.629Z",
    transform: "translate(119.526 4725.895)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 4718)",
    fill: "none",
    stroke: "#dae028",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 23.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub2);
export default __webpack_public_path__ + "static/media/GitHub_2.d3fbf88df6488a678b58d77147e7eb10.svg";
export { ForwardRef as ReactComponent };